import React, { VFC } from 'react';
import AppTabPanel from '../../Tabs/AppTabPanel';
import { Person } from '~/src/core/People/types';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tabPanel: {
    fontSize: '14px',
    color: theme.palette.text.primary,
    padding: theme.spacing(2, 1),
    minHeight: 14 * 1.5 * 2,
  },
}));

interface Props {
  person: Person;
  tabValue: number;
  index: number;
}

const RemarkTabPanel: VFC<Props> = ({ person, tabValue, index }) => {
  const classes = useStyles();
  return (
    <AppTabPanel
      key={person.id}
      hidden={tabValue ? index !== tabValue : index !== 0}
      aria-labelledby={`people-tab-${person.id}`}
      className={classes.tabPanel}
    >
      {person.remark}
    </AppTabPanel>
  );
};

export default RemarkTabPanel;
